export const NAMES: { [key: string]: string } = {
    ANNUITIES: "annuities",
};

export const SLUG_COMPANY_ID_MAP: { [key: string]: number } = {
    lg: 1,
    av: 3,
    cl: 5,
    jr: 29,
    sw: 28,
    sl: 30,
};

export const NOT_FOUND_COMPANY_ID = 0;
export const SCOTTISH_WIDOWS_ERROR_STATUS_CODE = 1923;
export const STANDARD_LIFE_PROCESSING_DELAY_MESSAGE =
    "Standard Life is taking longer than usual. It may take up to 8 weeks to process new applications.";
